import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../dashboard/DashboardIcons';

export default function HeaderHelpMenu({ onRaiseTicket, className = '' }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  return (
    <div className={`relative ${className}`} ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="topbar-help-dropdown-btn"
        className="flex items-center gap-1.5 rounded-xl border border-slate-200/80 bg-slate-50 px-3 py-2 text-xs font-bold text-slate-700 shadow-[0_1px_2px_rgba(0,0,0,0.03)] transition-all hover:border-slate-300 hover:bg-slate-100 hover:text-teal-800"
      >
        <Icon name="info" className="h-4 w-4 text-slate-400" />
        <span className="hidden sm:inline">المساعدة</span>
        <Icon name="chevronDown" className={`h-3 w-3 text-slate-400 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="absolute left-0 z-50 mt-2 w-64 rounded-2xl border border-slate-200/80 bg-white p-2 shadow-2xl" data-testid="topbar-help-dropdown-menu">
          <Link to="/help" onClick={() => setOpen(false)} data-testid="help-menu-link-center" className="flex items-center gap-2.5 rounded-xl px-3 py-2.5 text-sm font-semibold text-slate-700 transition-colors hover:bg-teal-50 hover:text-teal-800">
            <Icon name="document" className="h-4 w-4 text-teal-500" /> مركز المساعدة والأدلة
          </Link>
          <Link to="/help" onClick={() => setOpen(false)} data-testid="help-menu-link-faq" className="flex items-center gap-2.5 rounded-xl px-3 py-2.5 text-sm font-semibold text-slate-700 transition-colors hover:bg-teal-50 hover:text-teal-800">
            <Icon name="clipboard" className="h-4 w-4 text-teal-500" /> الأسئلة الشائعة
          </Link>
          <div className="my-1 border-t border-slate-100" />
          <button
            onClick={() => { setOpen(false); onRaiseTicket(); }}
            data-testid="help-menu-raise-ticket"
            className="flex w-full items-center gap-2.5 rounded-xl px-3 py-2.5 text-sm font-semibold text-slate-700 transition-colors hover:bg-teal-50 hover:text-teal-800"
          >
            <Icon name="inbox" className="h-4 w-4 text-teal-500" /> تواصل مع الدعم الفني
          </button>
        </div>
      )}
    </div>
  );
}
